var FilterableResult = require('../General/FilterableResult').FilterableResult;
var OrderRow = require('./OrderRow').OrderRow;
import $ from "jquery";

export class OrderListing extends React.Component {

    constructor(props) {
        super(props);
        this.filterableResult = React.createRef();
        this.state = {
            //member: props.initialState.extraData.member,
            sentForApproval: [],
        }
    }

    componentDidMount() {
        $(document).on('CartUpdated', this.filterableResult.current.updateData.bind(this.filterableResult.current));
    }

    renderRows(row, hidePrices) {

        var id = row.salesOrderId;
        if (id == null) {
            id = row.cartId;
        }

        var currentRow = row;
        currentRow.member = this.state.member;
        return <OrderRow order={currentRow} key={`order-${id}`} hidePrices={hidePrices} />;
    }

    renderData(resultCollection) {

        var totalHeader = "Total";
        if (this.props.hidePrices) {
            totalHeader = "";
        }

        return (
            <div className="list-group">
                <div className="row header">
                    <div className="col-6 col-hd">
                        <div className="order-header">Orders</div>
                    </div>
                    <div className="col-3 col-hd">
                        Items
                    </div>
                    <div className="col-3 col-hd">
                        <div className="total-header">{totalHeader}</div>
                    </div>
                </div>

                {resultCollection.map(x => this.renderRows(x, this.props.hidePrices))}
            </div>
        );
    }

    render() {

        var initialState = this.props.initialState;
        var baseUrl = null;

        if (this.props.limitToSite != null) {
            initialState = {
                filterCollection: [{
                    "type": "Dropdown",
                    "value": this.props.limitToSite.id,
                    "name": "siteList",
                 }],
                 resultMetadata: {
                     pageSize: 5
                 },

                hideFilter: true
            };
            baseUrl = "/orders/"
        }
        

        return (
            <div className="order-listing">
                <FilterableResult ref={this.filterableResult} initialState={initialState} renderData={this.renderData.bind(this)} baseUrl={baseUrl} />
            </div>
        );
    }

}